import cn from 'classnames';
import { PortalModal } from 'src/layout/PortalModal';

import s from './ModalWrapper.module.scss';

function CloseIcon({
  onClick,
  closeClassName = '',
}: {
  onClick(): void;
  closeClassName?: string;
}) {
  return (
    <div className={cn(s.closeWrapper, closeClassName)}>
      <svg
        onClick={onClick}
        className={s.close}
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          className={s.closeBg}
          width="56"
          height="56"
          rx="10.5"
          fill="#212830"
        />
        <path
          className={s.cross}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.7914 33.7165C20.3404 34.1676 20.3404 34.8988 20.7914 35.3498C21.2424 35.8009 21.9737 35.8009 22.4247 35.3498L28.1414 29.6332L33.858 35.3499C34.309 35.8009 35.0403 35.8009 35.4913 35.3499C35.9424 34.8988 35.9424 34.1676 35.4913 33.7165L29.7747 27.9999L35.4912 22.2833C35.9422 21.8323 35.9422 21.1011 35.4912 20.65C35.0402 20.199 34.3089 20.199 33.8579 20.65L28.1414 26.3666L22.4248 20.6501C21.9738 20.199 21.2426 20.199 20.7915 20.6501C20.3405 21.1011 20.3405 21.8323 20.7915 22.2834L26.508 27.9999L20.7914 33.7165Z"
          fill="white"
        />
      </svg>
    </div>
  );
}

interface ModalWrapperProps {
  children: React.ReactNode;
  className?: string;
  onClickForClose(): void;
  overlayClassName?: string;
  closeIcon?: React.ReactNode;
  closeClassName?: string;
  portalClassName?: string;
}

export function ModalWrapper({
  children,
  className = '',
  onClickForClose,
  overlayClassName = '',
  closeIcon,
  closeClassName,
  portalClassName = '',
}: ModalWrapperProps) {
  return (
    <PortalModal
      portalClassName={portalClassName}
      onClickForClose={onClickForClose}
      className={cn(s.root, className)}
      overlayClassName={cn(s.overlay, overlayClassName)}
      closeIcon={closeIcon}
      withoutDefaultCloseIcon
    >
      <CloseIcon onClick={onClickForClose} closeClassName={closeClassName} />
      {children}
    </PortalModal>
  );
}
